// extracted by mini-css-extract-plugin
export default {"Session_container":"Contact_Session_container__NVYVr","Contact_box_container":"Contact_Contact_box_container__IAbhm"};